import {
  MOBILE_WEB_HOSTNAME,
  MOBILE_WEB_HOSTNAME_DEV,
  MOBILE_WEB_HOSTNAME_QA,
  PC_WEB_HOSTNAME,
  PC_WEB_HOSTNAME_DEV,
  PC_WEB_HOSTNAME_QA,
} from '@/common/constant'

export const redirectMap = {
  [MOBILE_WEB_HOSTNAME]: PC_WEB_HOSTNAME,
  [MOBILE_WEB_HOSTNAME_DEV]: PC_WEB_HOSTNAME_DEV,
  [MOBILE_WEB_HOSTNAME_QA]: PC_WEB_HOSTNAME_QA,
}

export const REDIRECT_MAP = Object.freeze(redirectMap)
